import "./AdminSettings.css";
import TextField from '@mui/material/TextField';
import Grid from "@mui/material/Grid";
import Box from '@mui/material/Box';
import { useEffect, useState } from "react";
import AdminHeaderLinks from "../../components/adminHeaderLinks/AdminHeaderLinks.jsx"
import { requestGetSettings, requestUpdateSettings } from "../../services/wisdomServices/settingsService";
import { InputSwitch } from "primereact/inputswitch";
import { Button } from "primereact/button";
import { Can } from "../../security/Can.jsx";
import { PERMISSIONS } from "../../security/permissions.generated.js";

/**
 * @function AdminSettings
 * @returns {JSX.Element} - admin settings component
 */
function AdminSettings () {
    let [settings,setSettings] = useState(null);
   

    /**
     * @async
     * @function saveSettings
     * @description - persists current settings to the backend
     */
    let saveSettings = async () => {
        try {
            let settingsPayload = {
                settingName: "SSO",
                value: JSON.stringify(settings)
            }
            await requestUpdateSettings(settingsPayload)
            
        } catch (error) {
            console.error(error)
        }
    }
    /**
     * @async
     * @function listSettings
     * @description - updates component state
     */
    let listSettings = async () => {
        try {
            let settingsResponse = await requestGetSettings()
            let settings = JSON.parse(settingsResponse.value);
            setSettings(settings);
            
        } catch (error) {
            console.error(error)
        }
       
    }

    useEffect(() => {
        if(settings==null)
            listSettings();

    }, [])

    return (
   
    <div className="settingsContainer">
        <AdminHeaderLinks/>
        { settings && 
            <Box sx={{ flexGrow: 1 }} className="settingsBody">
                <Grid container spacing={2}>
                    <Grid size={10}>
                        <h3 className="settingsLabel">SSO settings</h3>
                    </Grid>
                    
                    <Grid size={6}>
                    <TextField
                        id="outlined-controlled"
                        label="Keycloak URL"
                        defaultValue={settings.keycloakURL}
                        className="txtField"
                        onChange={(e) => setSettings({...settings,keycloakURL : e.target.value})}
                    />
                    </Grid>
                    <Grid size={6} />

                    <Grid size={6}>
                    <TextField
                        id="outlined-controlled"
                        label="SSO Redirect URL"
                        defaultValue={settings.ssoRedirectUrl}
                        className="txtField"
                        onChange={(e) => setSettings({...settings,ssoRedirectUrl : e.target.value})}
                    />
                    </Grid>
                    <Grid size={6} />

                    <Grid size={6}>
                    <TextField
                        id="outlined-controlled"
                        label="realm"
                        defaultValue={settings.realm}
                        className="txtField"
                        onChange={(e) => setSettings({...settings,realm : e.target.value})}
                    />
                    </Grid>
                    <Grid size={6} />

                    <Grid size={6}>
                    <TextField 
                        id="outlined-controlled"
                        label="Client Id"
                        defaultValue={settings.clientID}
                        className="txtField"
                        minRows={5}
                        onChange={(e) => setSettings({...settings,clientID : e.target.value})}

                    />
                    </Grid>
                    <Grid size={6} />
                    <Grid size={6} >
                        <div className="system-settings-toggle-btns">
                            <div>
                                <label htmlFor="ShowSSO" className="ssoSwitchLabel" >Enable SSO</label>
                                <InputSwitch id="ShowSSO" checked={settings.showSSO} onChange={(e) => setSettings({...settings,showSSO : e.value})}/>
                                
                            </div>
                            <div>
                                <label htmlFor="ByPass" className="ssoSwitchLabel" >Bypass Login</label>
                                <InputSwitch id="ByPass" checked={settings.byPass} onChange={(e) => setSettings({...settings,byPass : e.value})}/>
                               
                            </div>
                        </div>
                    </Grid>
                    <Grid size={6} />
                    <Grid size={6}>
                        <Can permission={PERMISSIONS.settings_put}>
                            <Button title="save settings changes" label="Save Settings" severity="success"  onClick={() => saveSettings()}/>

                        </Can>
                    </Grid>
                </Grid>
            </Box>
        }
    </div>);
}

export default AdminSettings;